import React, { useContext, useMemo } from 'react';
import { FrameAnimation, FrameAnimationProps } from 'common-package';
import { useSelector } from 'react-redux';
import {
  RF_PLAN_FRAME_ANIMATION_CONFIG,
  RF_TECH_SOLUTION_TO_STATIC_SOLUTION,
} from '@/pages/service/massage-setting/utils';
import { MassageControlValueContext } from '@/pages/service/massage-control';
import { selectCurrentServingOrder } from '@/store/service';
import ShoulderRFOutlineImg from '@/assets/image/shoulder-rf-outline.png';
import WaistRFOutlineImg from '@/assets/image/waist-rf-outline.png';
import NeckRFOutlineImg from '@/assets/image/neck-rf-outline.png';
import BackRFOutlineImg from '@/assets/image/back-rf-outline.png';
import AbdomenRFOutlineImg from '@/assets/image/abdomen-rf-outline.png';

import cx from './index.module.scss';

interface Props {
  animationType: RFAnimationTpye;
  style?: React.CSSProperties;
  className?: string;
}

export type RFAnimationTpye = 'shoulder-rf' | 'waist-rf' | 'neck-rf' | 'abdomen-rf' | 'back-rf';

const RFAnimation: React.FC<Props> = ({ style, className, animationType }) => {
  const currentServingOrder = useSelector(selectCurrentServingOrder);
  const { massageState, currentMassageType } = useContext(MassageControlValueContext);

  const modelSolution = useMemo(() => currentServingOrder?.modelConfig?.[0]?.value, [currentServingOrder?.modelConfig]);

  return (
    <div className={cx('animation-wrapper')}>
      {animationType === 'shoulder-rf' && (
        <div className={cx('shoulder-rf-animation', className)} style={style}>
          <img src={ShoulderRFOutlineImg} className={cx('img', 'img-1')} alt="" />
          <img src={ShoulderRFOutlineImg} className={cx('img', 'img-2')} alt="" />
        </div>
      )}
      {animationType === 'waist-rf' && (
        <div className={cx('waist-rf-animation', className)} style={style}>
          <img src={WaistRFOutlineImg} className={cx('img', 'img-1')} alt="" />
          <img src={WaistRFOutlineImg} className={cx('img', 'img-2')} alt="" />
        </div>
      )}
      {animationType === 'back-rf' && (
        <div className={cx('back-rf-animation', className)} style={style}>
          <img src={BackRFOutlineImg} className={cx('img', 'img-1')} alt="" />
          <img src={BackRFOutlineImg} className={cx('img', 'img-2')} alt="" />
        </div>
      )}
      {animationType === 'neck-rf' && (
        <div className={cx('neck-rf-animation', className)} style={style}>
          <img src={NeckRFOutlineImg} className={cx('img', 'img-1')} alt="" />
          <img src={NeckRFOutlineImg} className={cx('img', 'img-2')} alt="" />
        </div>
      )}
      {animationType === 'abdomen-rf' && (
        <div className={cx('abdomen-rf-animation', className)} style={style}>
          <img src={AbdomenRFOutlineImg} className={cx('img', 'img-1')} alt="" />
          <img src={AbdomenRFOutlineImg} className={cx('img', 'img-2')} alt="" />
        </div>
      )}
      {/* 在机器治疗阶段渲染射频手法动画 */}
      {!!RF_TECH_SOLUTION_TO_STATIC_SOLUTION[modelSolution] && currentMassageType === 'Massage' && (
        <div className={cx('rf-tech-animation', modelSolution, { show: massageState === 'Running_Massaging' })}>
          <FrameAnimation
            isPlay={massageState === 'Running_Massaging'}
            width={200}
            {...(RF_PLAN_FRAME_ANIMATION_CONFIG[modelSolution] as FrameAnimationProps)}
          />
        </div>
      )}
    </div>
  );
};

export default RFAnimation;
